import { render, staticRenderFns } from "./LoanApplication.vue?vue&type=template&id=1b23bf52"
import script from "./LoanApplication.vue?vue&type=script&lang=js"
export * from "./LoanApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports